export const ENGLISH_NAME_ALLOWED = /[^A-Za-z0-9!.\s]/g;
// eslint-disable-next-line no-useless-escape
export const COMPANY_NAME_ALLOWED = /[^A-Za-z0-9 .,\-_/&()\[\]]/g;